import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

interface PassedProps {
  selected?: boolean;
}

export const styles = makeStyles(theme => ({
  categoryButton: ({ selected }: PassedProps) => ({
    border: selected
      ? `2px solid ${themeColor.secondaryMain}`
      : `2px solid ${themeColor.secondaryLight}`,
    color: theme.palette.info.dark,
    marginRight: '0.73vw',
    marginTop: '1.82vh',
    textTransform: 'none',
    '&:hover': {
      background: themeColor.white,
    },
  }),
  categoryButtonTitle: {
    fontSize: vh(2.08),
    lineHeight: 1,
    fontWeight: 500,
  },
}));
